import {
  CircularProgress,
  Typography
} from "@mui/material";
import {
  Check as CheckIcon,
  Close as CloseIcon
} from "@mui/icons-material";

const StatusIcon = ({ state }) => {
  if (state === "loading") {
    return <CircularProgress />
  }

  return state === "checked" ? <CheckIcon color="success" /> : <CloseIcon color="warning" />
}

const StatusBadge = ({
  state,
  label,
  ...props
}) => {
  return (
    <Typography
      variant="body1"
      component="div"
      sx={{ display: "flex", pb: 2, flexDirection: "row" }}
      {...props}
    >
      <StatusIcon state={state} />{label}
    </Typography>
  );
}

export default StatusBadge;
